module.exports = __webpack_public_path__ + "static/media/header_cat.f6750385.png";